module.exports = __webpack_public_path__ + "img/govt.84c9a370.png";